require('../../modules/es6.number.is-integer');
module.exports = require('../../modules/_core').Number.isInteger;


//////////////////
// WEBPACK FOOTER
// ../~/.2.4.1@core-js/library/fn/number/is-integer.js
// module id = 49
// module chunks = 0